import { fileAssetUrl } from "../../../utils/fileAssetUrl";
import { groupStoredFiles } from "../inventory/inventoryUploadUtils";

function FileGroup({ title, groups, kind }) {
  if (!groups.length) return null;
  return (
    <div className="inv-file-group">
      <span className="inv-file-label">{title}</span>
      {groups.map((group) => (
        <div key={group.id} className="inv-file-category">
          <span className="inv-file-category__name">{group.label}</span>
          {kind === "image" ? (
            <div className="inv-file-grid">
              {group.files.map((file, index) => {
                const src = fileAssetUrl(file);
                return (
                  <a key={`${group.id}-${index}`} href={src} target="_blank" rel="noreferrer">
                    <img src={src} alt={`${group.label} ${index + 1}`} />
                  </a>
                );
              })}
            </div>
          ) : (
            <ul>
              {group.files.map((file, index) => (
                <li key={`${group.id}-${index}`}>
                  <a href={fileAssetUrl(file)} target="_blank" rel="noreferrer">
                    {group.label} {index + 1}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}

export default function InventoryFilesGallery({ confirmation }) {
  const images = confirmation?.inventoryImages || [];
  const videos = confirmation?.inventoryVideos || [];
  const pdfs = confirmation?.inventoryPdfs || [];
  const meta = confirmation?.inventoryFileMeta || [];

  if (!images.length && !videos.length && !pdfs.length) {
    return <p className="lrms-section__hint">No inventory files uploaded yet.</p>;
  }

  return (
    <div className="inv-existing lrms-inventory-gallery">
      <FileGroup title="Photos" groups={groupStoredFiles(images, meta, "image")} kind="image" />
      <FileGroup title="Videos" groups={groupStoredFiles(videos, meta, "video")} kind="video" />
      <FileGroup title="PDFs" groups={groupStoredFiles(pdfs, meta, "pdf")} kind="pdf" />
    </div>
  );
}
